import { Book, Chapter } from '../../../types';
import './chapter-index.css';

interface ChapterIndexProps {
  chapters: Chapter[];
  chapter: Chapter;
  book: Book;
}

export const ChapterIndex = ({
  chapters,
  chapter: currentChapter,
  book,
}: ChapterIndexProps) => {
  return (
    <nav class="chapter-index">
      <ul>
        {chapters.map((chapter) => (
          <li>
            <a
              href={`/f/${book.permalink}/c/${chapter.permalink}`}
              className={chapter.id === currentChapter.id ? 'active' : ''}
            >
              {chapter.title}
            </a>
            {chapter.isPremium && (
              <span className="premium">(Premium Chapter)</span>
            )}

            {chapter.isDraft && <span className="draft">(Draft Chapter)</span>}
          </li>
        ))}
      </ul>
    </nav>
  );
};
